import { ZAppManifest } from '../external-app/types/manifest';

export const DexManifest: ZAppManifest = {
  title: 'Swap',
  route: '/swap',
  url: 'https://swap-z.platform.gateway.fm',
  features: [],
};
